module.exports = __webpack_public_path__ + "img/7.cde1455f.png";